<template>
  <div class="shadow-md rounded-md bg-surface-0 dark:bg-surface-900 p-4">
    <slot />
  </div>
</template>
